import React, { useState, useCallback } from 'react'
import { Pressable, ViewStyle, ColorValue, PressableProps } from 'react-native'

type Props = PressableProps & {
  hoverColor?: ColorValue
  pressedColor?: ColorValue
  disabledStyle?: ViewStyle
}
export const StyledPressable: React.FC<Props> = ({
  hoverColor,
  pressedColor,
  disabledStyle,
  onHoverIn: propOnHoverIn,
  onHoverOut: propOnHoverOut,
  ...props
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const onHoverIn: NonNullable<PressableProps['onHoverIn']> = useCallback(
    e => {
      setIsHovered(true)
      propOnHoverIn?.(e)
    },
    [propOnHoverIn],
  )

  const onHoverOut: NonNullable<PressableProps['onHoverOut']> = useCallback(
    e => {
      setIsHovered(false)
      propOnHoverOut?.(e)
    },
    [propOnHoverOut],
  )

  return (
    <Pressable
      {...props}
      style={state => [
        props.disabled
          ? disabledStyle
          : // NOTE: no hover while disabled
            isHovered && {
              backgroundColor: hoverColor,
            },
        state.pressed && {
          backgroundColor: pressedColor,
        },
        typeof props.style === 'function' ? props.style(state) : props.style,
      ]}
      onHoverIn={onHoverIn}
      onHoverOut={onHoverOut}
    />
  )
}
